import { useState, useEffect } from "react";

// Owner-only "Roadmap View" toggle. When ON, nav tabs show a "+N" badge for the
// open roadmap items linked to that page, and those items surface as an in-page
// blurred overlay (no navigation). Persisted in localStorage + synced via the
// "rosterly-roadmap-view" event so the nav toggle, badges and overlay stay in step.
const KEY = "rosterly_roadmap_view";

export function readRoadmapView() {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function setRoadmapView(on) {
    try { localStorage.setItem(KEY, on ? "1" : "0"); } catch { /* noop */ }
    window.dispatchEvent(new Event("rosterly-roadmap-view"));
}

export function useRoadmapView() {
    const [on, setOn] = useState(readRoadmapView);
    useEffect(() => {
        const update = () => setOn(readRoadmapView());
        window.addEventListener("rosterly-roadmap-view", update);
        window.addEventListener("storage", update);
        return () => {
            window.removeEventListener("rosterly-roadmap-view", update);
            window.removeEventListener("storage", update);
        };
    }, []);
    return on;
}
